<script setup>
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <div class="min-h-screen flex flex-col justify-center items-center pt-6 sm:pt-0 ">
        <div class="flex flex-col gap-8 w-full sm:max-w-xl px-11 py-14 -mt-10 sm:mt-0 bg-white overflow-hidden sm:rounded-2xl sm:ring-1 sm:ring-slate-200">
            <div class="w-full sm:max-w-md flex flex-col items-start justify-center">
                <ApplicationLogo class="w-auto h-12 fill-current text-gray-500" />
            </div>
            <slot />
        </div>
    </div>
</template>

